Element.prototype.find = Element.prototype.querySelector;
Element.prototype.findAll = Element.prototype.querySelectorAll;

// shortcut for addEventListener: find('.movie-info').on('click', (e) => { ....
Element.prototype.on = Element.prototype.addEventListener;

Element.prototype.show = function () {
    this.style.display = this.dataset._display || 'block';
}

Element.prototype.hide = function () {
    this.dataset._display = window.getComputedStyle(this, null).display; // remember original display
    this.style.display = 'none';
}

// Slide down / reveal an element
Element.prototype.slideDown = function (duration = 700) {
    // Clear any running animations
    if (this._slideAnimationTimeout) {
        clearTimeout(this._slideAnimationTimeout);
        this._slideAnimationTimeout = null;
    }

    this.style.display = this.dataset._display || 'block';
    this.style.height = '0px';
    this.style.overflow = 'hidden';
    this.style.transition = `height ${duration}ms cubic-bezier(0.25, 1, 0.5, 1)`;

    const height = this.scrollHeight + 'px';
    requestAnimationFrame(() => {
        this.style.height = height;
        this._slideAnimationTimeout = setTimeout(() => {
            this.style.height = '';
            this.style.overflow = '';
            this.style.transition = '';
            this._slideAnimationTimeout = null;
        }, duration);
    });
}

// Slide up / hide an element
Element.prototype.slideUp = function (duration = 700) {
    // Clear any running animations
    if (this._slideAnimationTimeout) {
        clearTimeout(this._slideAnimationTimeout);
        this._slideAnimationTimeout = null;
    }

    this.style.overflow = 'hidden';
    this.style.transition = `height ${duration}ms cubic-bezier(0.25, 1, 0.5, 1)`;

    const height = this.scrollHeight + 'px';
    this.style.height = height; // set to current height first
    requestAnimationFrame(() => {
        this.style.height = '0px'; // then animate to 0
        this._slideAnimationTimeout = setTimeout(() => {
            this.style.display = 'none'; // hide after animation
            this.style.height = '';
            this.style.overflow = '';
            this.style.transition = '';
            this._slideAnimationTimeout = null;
        }, duration);
    });
}

// bind helper functions to global

window.find = document.querySelector.bind(document);
window.findAll = document.querySelectorAll.bind(document);